import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getWorkOrderList as getWorkOrderListApi,
	getWorkOrderListQuery as getWorkOrderListQueryApi,
	getWorkOrderApi,
	addNewWorkOrderApi,
	updateWorkOrderApi,
	deleteWorkOrderApi,
} from '../../helpers/work_order/api_helper';

export const getWorkOrderList = createAsyncThunk(
	'workOrder/getWorkOrderList',
	async params => {
		try {
			const response = await getWorkOrderListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las obras.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getWorkOrderListQuery = createAsyncThunk(
	'workOrder/getWorkOrderListQuery',
	async params => {
		try {
			const response = getWorkOrderListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWorkOrder = createAsyncThunk(
	'workOrder/getWorkOrder',
	async work_order_id => {
		try {
			const response = await getWorkOrderApi(work_order_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la obra.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addNewWorkOrder = createAsyncThunk(
	'workOrder/addNewWorkOrder',
	async work_order => {
		try {
			const response = await addNewWorkOrderApi(work_order);
			toast.success('Obra creada exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al crear la obra.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateWorkOrder = createAsyncThunk(
	'workOrder/updateWorkOrder',
	async work_order => {
		try {
			const response = await updateWorkOrderApi(work_order);
			toast.success('Obra actualizada exitosamente.', { autoClose: 3000 });
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la obra.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteWorkOrder = createAsyncThunk(
	'workOrder/deleteWorkOrder',
	async work_order => {
		try {
			await deleteWorkOrderApi(work_order._id);
			toast.success('Obra eliminada exitosamente.', { autoClose: 3000 });
			return work_order;
		} catch (error) {
			toast.error('Error al eliminar la obra.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
